import React from 'react';
import PropTypes from 'prop-types';
import { OrderedMap, Set, Map } from 'immutable';

import PaymentMethodModel from 'models/payment-method';

import BraintreeField from 'components/payment-methods/payment-method-form/braintree-field';

const propTypes = {
  // Turn off linter on props that we want to validate here,
  // but that are then passed through via ...this.props
  /* eslint-disable react/no-unused-prop-types*/
  onFieldEvent: PropTypes.func.isRequired,
  requiredFields: PropTypes.instanceOf(Set).isRequired,
  requiredFieldErrors: PropTypes.oneOfType([
    PropTypes.instanceOf(OrderedMap),
    PropTypes.instanceOf(Map),
  ]).isRequired,
  shouldScrollToError: PropTypes.bool,
  setShouldScrollToError: PropTypes.func.isRequired,
  modifyRequiredFieldList: PropTypes.func.isRequired,
  braintreeFieldStateChange: PropTypes.func.isRequired,
  /* eslint-enable react/no-unused-prop-types*/

  showNicknameField: PropTypes.bool,
  existingPaymentMethod: PropTypes.instanceOf(PaymentMethodModel),
  trackEvent: PropTypes.func,
};

const defaultProps = {
  shouldScrollToError: false,
  showNicknameField: false,
  existingPaymentMethod: false,
  trackEvent: () => {},
};

class BraintreeFields extends React.Component {
  constructor(props) {
    super(props);

    this.handleNicknameFieldChange = this.handleNicknameFieldChange.bind(this);
    this.renderNicknameField = this.renderNicknameField.bind(this);

    this.state = {
      nicknameValue: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.existingPaymentMethod || !nextProps.existingPaymentMethod.get('label')) { return; }

    const newInputValue = nextProps.existingPaymentMethod.get('label').toString();
    if (!this.props.existingPaymentMethod) {
      this.setState({ nicknameValue: newInputValue });
    }
  }

  handleNicknameFieldChange(e) {
    this.setState({ nicknameValue: e.target.value });
  }

  renderNicknameField() {
    const { existingPaymentMethod } = this.props;
    return (
      <div className="col-xs-12 col-md-7 form-group">
        <label htmlFor="card-nickname">
          CARD NICKNAME
        </label>
        <input
          id="card-nickname"
          onChange={this.handleNicknameFieldChange}
          value={this.state.nicknameValue}
          data-field-name="card-nickname"
          className="braintree-field form-control"
          placeholder="e.g. Personal Card"
          defaultValue={existingPaymentMethod && existingPaymentMethod.get('label')}
        />
      </div>
    );
  }

  render() {
    const { existingPaymentMethod, trackEvent } = this.props;
    return (
      <div>
        <div className="row">
          <BraintreeField
            {...this.props}
            id="bt-number"
            name="CARD NUMBER"
            data-field-name="number"
            data-braintree-name="number"
            className="col-xs-12 form-group"
            placeholderText={existingPaymentMethod ? `************${existingPaymentMethod && existingPaymentMethod.get('lastFourDigits')}` : 'Your Card Number'}
            inputType="tel"
            trackEvent={trackEvent}
          />
          <BraintreeField
            {...this.props}
            id="bt-exp-month"
            name="EXPIRATION DATE (MM/YYYY)"
            data-field-name="expirationMonth"
            data-braintree-name="expiration_month"
            className="col-xs-6 col-md-4 form-group"
            labelClassName="no-wrap"
            placeholderText="Month"
            defaultValue={existingPaymentMethod && existingPaymentMethod.get('expirationMonth')}
            inputType="tel"
            trackEvent={trackEvent}
          />
          <BraintreeField
            {...this.props}
            id="bt-exp-year"
            data-field-name="expirationYear"
            data-braintree-name="expiration_year"
            className="col-xs-6 col-md-4 form-group bt-exp-year-wrap"
            placeholderText="Year"
            defaultValue={existingPaymentMethod && existingPaymentMethod.get('expirationYear')}
            inputType="tel"
            trackEvent={trackEvent}
          />
          <BraintreeField
            {...this.props}
            id="bt-cvv"
            name="CVV:"
            data-field-name="cvv"
            data-braintree-name="cvv"
            className="col-xs-5 col-md-3 col-md-offset-1 form-group cvv-label"
            placeholderText='CVV'
            inputType="tel"
            trackEvent={trackEvent}
          />
          <BraintreeField
            {...this.props}
            id="bt-postal-code"
            name="POSTAL CODE"
            data-field-name="postalCode"
            className="col-xs-7 col-md-5 form-group"
            placeholderText="Postal Code"
            defaultValue={existingPaymentMethod && existingPaymentMethod.get('postalCode')}
          />
          { this.props.showNicknameField ? this.renderNicknameField() : null }
        </div>
      </div>
    );
  }
}

BraintreeFields.propTypes = propTypes;
BraintreeFields.defaultProps = defaultProps;

export default BraintreeFields;
